// @ts-nocheck


import React from 'react';


import { tireApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';




export default ({ filter = {}, withMnemocode, ...selectProps }) =>
<AutocompleteSelect
  fetch={async (params) => {
    return await tireApi.fetchTires({
      ...filter,
      ...params
    });
  }}
  refetchParams={{ filter }}
  fetchSingle={tireApi.fetchTire}
  notFoundText="Шины не найдены"
  placeholder="Выберите шину"
  renderOption={(tire, Option) =>
  <Option key={tire.id} value={tire.id} tire={tire}>
        {tire.name}
        {withMnemocode ? ` - ${tire.code ?? 'Мнемокод отсутствует'}` : ''}
      </Option>
  }
  {...selectProps} />;
